if (!customElements.get('planted-modal')) {
  class PlantedModal extends HTMLElement {
    connectedCallback() {
      const modalId = this.getAttribute('data-id')
      const hash = this.getAttribute('data-hash')
      const modalEl = document.querySelector(`[data-modal-id="${modalId}"]`)
      const closeEls = modalEl.querySelectorAll('[data-close]')
      let initialOverScroll
      this.addEventListener(
        'click',
        function (event) {
          event.preventDefault()
          open()
        }.bind(this)
      )

      if (hash && location.hash === hash) {
        open()
      }

      function open() {
        modalEl.style.opacity = 1
        modalEl.style.pointerEvents = 'auto'
        initialOverScroll = document.body.style.overflow
        document.body.style.overflow = 'hidden'
      }

      function close() {
        modalEl.style.opacity = 0
        modalEl.style.pointerEvents = 'none'
        document.body.style.overflow = initialOverScroll
      }

      if (closeEls) {
        closeEls.forEach(function (closeEl) {
          closeEl.addEventListener('click', function () {
            close()
          })
        })
      }

      modalEl.addEventListener('click', function (event) {
        if (
          event.target === modalEl ||
          !event.target.closest('[data-content]')
        ) {
          close()
        }
      })
    }
  }
  customElements.define('planted-modal', PlantedModal)
}
